module.exports = __webpack_public_path__ + "static/media/expiiIconFeature2.a55d677b.jpg";